export * from '@primeuix/themes/aura/terminal';
export { default } from '@primeuix/themes/aura/terminal';
